import { AppraisalInterviewStatusesEnum } from '@thinknet-gmbh/platform-common';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

export const APPRAISAL_INTERVIEW_STATUSES_STYLES = {
  [AppraisalInterviewStatusesEnum.ACTIVE]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [AppraisalInterviewStatusesEnum.CLOSED]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
};
